import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './ui/arc/foundation.css';
import App from './App';
import OrderTracking from './OrderTracking';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Pantalla pública de seguimiento (sin login) — no monta el admin.
const isTracking = window.location.pathname.startsWith('/seguimiento/');

root.render(
  <React.StrictMode>
    {isTracking ? <OrderTracking /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// PWA: registrar el service worker para que la app sea instalable en iOS/Android.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch((err) => {
      console.warn('SW registration failed:', err);
    });
  });
}
